module.exports = __webpack_public_path__ + "static/media/22791778_1629546257120559_3127368208062346928_o.6aa32025.jpg";